<template>
  <div>
    <div class="lp-address-container" v-for="(address,idx) in address_list" :key="`address-list-${idx}`">
      <div class="flex-align">
        <i class="material-icons address-remove-icon unselect" @click="removeAddress(idx)">remove_circle_outline</i>
        <input class="input" v-model="address.title" placeholder="주소 타이틀을 입력하세요.">
        <button style="margin-left: 20px"
                class="button is-danger" @click="openEditAddress(idx)">주소 편집</button>
      </div>
    </div>
    <div class="flex-center">
      <button class="button is-primary" @click="addAddress">+ 주소 추가하기</button>
    </div>

    <!-- 주소 편집 팝업 -->
    <modal name="editAddressModal" :adaptive="true" :width="800" height="auto" class="modal-style">
      <div class="lp-modal-wrapper" v-if="selectedAddress!==undefined">
        <admin-box-item title="주소 편집" :useTab="false">
          <div class="flex-align">
            <input class="input" v-model="selectedAddress.title" placeholder="주소 타이틀을 입력하세요.">
          </div>
          <input class="lp-address-zipcode input" v-model="selectedAddress.post_code" type="text" readonly>
          <button class="button is-primary"
                  @click="openDaumPostcode" style="height: 31.5px;">주소 검색</button>
          <input class="lp-address-detail-1 input" v-model="selectedAddress.new" type="text" readonly
                 :style="inputStyle" style="display:block"  @click="openDaumPostcode">
          <input :disabled="!selectedAddress.sido" class="lp-address-detail-2 input"
                 :value="selectedAddress.detail" @input="e => inputDetail(e)" type="text"
                 :placeholder="address_detail_ph[selectedAddressIndex]" :style="inputStyle"
                 @focus="address_detail_ph[selectedAddressIndex] = ''" @blur="address_detail_ph[selectedAddressIndex] = '상세 주소를 입력하세요.'">

          <div class="btn-group-justify-end">
            <button class="button is-light" style="margin-left:0" @click="cancelAddressModal">취소</button>
            <button class="button is-primary" style="margin-left:6px;" @click="editAddress">확인</button>
          </div>
        </admin-box-item>
      </div>
    </modal>
  </div>
</template>

<script>

  export default {
    name: 'lp-address-list',
    head: {
      script() {
        return [
          {type: 'text/javascript', src: 'https://ssl.daumcdn.net/dmaps/map_js_init/postcode.v2.js', head: true}
        ];
      }
    },
    props: ['data', 'inputWidth'],
    data() {
      return {
        address_detail_ph: [],
        address_list: [],
        selectedAddressIndex: 0,
        selectedAddress: undefined
        /*address: {
          sido: '',
          sigungu: '',
          dong: '',
          detail: '',
          post_code: '',
          old: '',
          new: '',
          latitude: '',
          longitude: ''
        }*/
      }
    },

    created() {
      this.address_list = this.data;
    },
    computed: {
      inputStyle() {
        if (this.inputWidth !== undefined) {
          return 'width:' + this.inputWidth;
        }
      }
    },
    watch: {
      data(n) {
        this.address_list = this.data;
      },
      address_list(n) {
        this.$emit('update:data', n);
      }
    },
    methods: {
      cancelAddressModal () {
        this.$modal.hide('editAddressModal');
        if(!this.selectedAddress.sido) {
          removeIndex(this.address_list, this.selectedAddressIndex);
        }
      },
      editAddress () {
        if(!this.selectedAddress.sido) {
          this.toast('주소를 선택하고 확인하시기바랍니다.');
          return;
        }
        this.address_list[this.selectedAddressIndex] = this.selectedAddress;
        this.$modal.hide('editAddressModal');
      },
      openEditAddress (idx) {
        this.selectedAddressIndex = idx;
        this.selectedAddress = this.address_list[idx];
        this.$modal.show('editAddressModal');
      },
      addAddress () {
        this.address_list.push(
          {
            sido: '',
            sigungu: '',
            dong: '',
            detail: '',
            post_code: '',
            old: '',
            new: '',
            latitude: '',
            longitude: '',
            title: ''
          }
        );
        this.address_detail_ph.push('');
        this.selectedAddressIndex = this.address_list.length-1;
        this.selectedAddress = this.address_list[this.address_list.length-1];
        this.$modal.show('editAddressModal');
      },
      removeAddress (idx) {
        this.address_list.splice(idx, 1);
        this.address_detail_ph.splice(idx,1);
      },
      inputDetail(e){
        this.selectedAddress.detail = e.target.value;
        this.selectedAddress.full = this.selectedAddress.new + ' ' + this.selectedAddress.detail;
      },
      openDaumPostcode() {
        daum.postcode.load(() => {
          new daum.Postcode({
            width: 500,
            height: 600,
            popupName: 'daumPostPopup',
            oncomplete: data => {
              this.selectedAddress.sido = data.sido;
              this.selectedAddress.sigungu = data.sigungu;
              this.selectedAddress.dong = data.bname;
              this.selectedAddress.old = (data.jibunAddress) ? data.jibunAddress : data.autoJibunAddress;
              this.selectedAddress.new = (data.roadAddress) ? data.roadAddress : data.autoRoadAddress;
              this.selectedAddress.post_code = data.postcode;
              this.selectedAddress.full = this.selectedAddress.new + ' ' + this.selectedAddress.detail;
              this.address_detail_ph[this.selectedAddressIndex] = "상세 주소를 입력하세요.";

              this.setPosition();
            }
          }).open({
            left: (window.screen.width / 2) - (500 / 2),
            top: (window.screen.height / 2) - (600 / 2)
          });
        });
      },
      setPosition() {
        console.log(this.backendUrl+'/public/service/geocode?address=' + encodeURI(this.selectedAddress.old));
        this.$axios.get(this.backendUrl+'/public/service/geocode?address=' + encodeURI(this.selectedAddress.old))
          .then(res => {
            console.log(res);
            this.selectedAddress.latitude = res.data.position.latitude;
            this.selectedAddress.longitude = res.data.position.longitude;
          }).catch(err => {
            console.log(err)
        });
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
  .address-input
    padding 8px 12px
    font-size .9rem
    color #555
    border-radius 3px
    display block
    margin-bottom 4px
    width 380px
    border 0
    background-color #f2f7f8

  .lp-address-zipcode
    display inline-block
    width 92px
    margin-right 10px

  .lp-address-find-btn
    padding 4px 12px
    background #ddd
    color #666
    display inline-block
    border-radius 3px
    font-size 0.85rem

  input
    margin-bottom 4px

  .lp-address-container
    margin-bottom 30px

  .address-remove-icon
    color $negative
    font-size 20px
    margin-right 6px

  // .lp-address-detail-1

  // .lp-address-detail-2

</style>
